export default __webpack_public_path__ + "static/sanlingdabus-f1e5bb44da7aef2db65742e68280cc04.png";